import { Route, Routes } from "react-router-dom";
import "./App.css";
import Login from "./pages/Login/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
import "bootstrap/dist/css/bootstrap.min.css";
import Pagetracker from "./Hook/Pagetracker";
import InboundRoute from "./Routes/private/Inbound/InboundRoute";
import WarehouseRoute from "./Routes/private/Warehouse/Wahehouse";
import OutboundRoute from "./Routes/private/Outbound/OutboundRoute";
import ReportRoute from "./Routes/private/ReportRoutes/ReportRoutes";
import UserManagementRoute from "./Routes/private/UserManagementRoute/UserManagement";
import DevRoute from "./Routes/private/Dev/DevRoute";
import MasterRoute from "./Routes/private/Master/MasterRoute";
import AssemblyRoute from "./Routes/private/Assembly/AssemblyRoute";
import Testfile from "./pages/Dev/Testfile";
import SettingRoute from "./Routes/private/Setting/SettingRoute";
import Test from "./pages/Test";
import InboundReturnRoute from "./Routes/private/Inbound-return/InboundReturnRoute";

const App = () => {
  return (
    <>
      <Pagetracker />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/test" element={<Testfile />} />
        <Route path="/testpop" element={<Test/>} />
        <Route path="/dashboard/" element={<Dashboard />} />
        <Route path="/inbound*" element={<InboundRoute />} />  {/* inbound */}
        <Route path="/dev/*" element={<DevRoute />} />  {/* Dev */}
         <Route path="outbound/*" element={<OutboundRoute />} /> {/*outbound */} 
         <Route path="/master*" element={<MasterRoute />} /> {/*master */} 
         <Route path="/assmbly*" element={<AssemblyRoute />} /> {/*master */} 
         <Route path="/setting*" element={<SettingRoute />} /> {/*master */} 
        <Route path="/warehouse*" element={<WarehouseRoute />} /> {/*warehouse/ */} 
        <Route path="/report*" element={<ReportRoute />} /> {/*report/*/} 
        <Route path="/inbound-return*" element={<InboundReturnRoute />} /> {/*inbound return/*/} 
       <Route path="/usermanage*" element={<UserManagementRoute />} />  {/*/user-management */} 
      </Routes>
    </>
  );
};

export default App;
